import { Dialog, IconButton, Stack, Tooltip } from "@mui/material";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import React from "react";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles<Theme, PopupDialogProps>((theme) => ({
  newPosOfDialog: {
    padding: 24,
    maxWidth: 500,
    minHeight: 200,
    backgroundColor: "#FFFFFF",
    border: `2px solid ${theme.palette.divider}`,
    borderRadius: 15,
  },
  buttonNo: {
    width: (props) => (props.ctaFooterVariant === "stretched" ? "100%" : "auto"),
    borderRadius: 16,
    backgroundColor: "#D8D8D8",
    color: theme.palette.text.primary,
    "&:hover": {
      backgroundColor: "#C9C8C8",
    },
  },
  buttonYes: {
    width: (props) => (props.ctaFooterVariant === "stretched" ? "100%" : "auto"),
    borderRadius: 16,
  },
  closeButton: {
    color: theme.palette.text.secondary,
  },
}));

interface PopupDialogProps {
  popupTitle: string;
  promptOpen: boolean;
  handleClose: (e: any) => void;
  handleOkClick: (e: any) => void;
  handleCancelClick: (e: any) => void;
  okButtonLabel: string;
  cancelButtonLabel?: string;
  children: React.ReactNode;
  ctaFooterVariant: "stretched" | "default";
  "aria-describedby"?: string;
}

export const PopUpDialog = (props: PopupDialogProps) => {
  const classes = useStyles(props);
  const {
    handleOkClick,
    handleCancelClick,
    okButtonLabel,
    cancelButtonLabel,
    promptOpen,
    children,
    handleClose,
    popupTitle,
  } = props;
  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      classes={{
        paper: classes.newPosOfDialog,
      }}
      onClose={handleClose}
      aria-labelledby="dialog-title"
      open={promptOpen}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems={"center"}
        sx={{ marginBottom: "16px" }}>
        <Typography id="dialog-title" variant="h4" sx={{ fontSize: "1.25rem" }}>
          {popupTitle}
        </Typography>
        <Tooltip placement="bottom-end" title="Close" arrow describeChild>
          <IconButton
            onClick={(e) => {
              handleClose(e);
            }}
            aria-label="Close Dialog"
            className={classes.closeButton}>
            <CloseIcon />
          </IconButton>
        </Tooltip>
      </Stack>
      {children}
      <Stack
        direction="row"
        justifyContent="flex-end"
        gap={"16px"}
        sx={{ marginTop: "24px" }}>
        {cancelButtonLabel && (
          <Button
            onClick={(e) => {
              handleCancelClick(e);
            }}
            variant="contained"
            color="primary"
            size="large"
            className={classes.buttonNo}>
            {cancelButtonLabel}
          </Button>
        )}
        <Button
          onClick={(e) => {
            handleOkClick(e);
          }}
          variant="contained"
          color="primary"
          size="large"
          className={classes.buttonYes}>
          {okButtonLabel}
        </Button>
      </Stack>
    </Dialog>
  );
};
